import type { FeatureConfig } from '@skynet/feature-config';
import { HeatMapOutlined } from '@ant-design/icons';
import { TOKEN_MAPPING_LIST_URL, TOKEN_MAPPING_ROUTE_PATH } from './routes';

/**
 * Feature manifest for the admin Token Mapping list page. The dashboard shell
 * reads this single source of truth instead of hardcoding the route, navigation
 * entry, header label and Cerbos action across its routing, navigation, header
 * and access-control modules.
 *
 * `route.load` is a dynamic-import thunk, so importing this config for its
 * nav/header metadata never pulls the page implementation into the main bundle.
 * The config imports nothing from `@skynet/sky-token-map`, so reading it never
 * drags the Token Mapping UI onto the boot path.
 *
 * `section`, `nav.key` and `cerbosAction` stay literal: they are the identifier
 * the Cerbos policy is written against (`read:admin:token-mapping`), and
 * renaming any of them hides the nav item until the policy is renamed too.
 */
export const tokenMappingConfig = {
  domain: 'Admin',
  section: 'token-mapping',
  route: {
    path: TOKEN_MAPPING_ROUTE_PATH,
    load: async () => ({ default: (await import('./TokenMapping')).TokenMapping }),
  },
  nav: {
    key: 'admin.token-mapping',
    label: 'Token Mapping',
    icon: <HeatMapOutlined />,
    url: TOKEN_MAPPING_LIST_URL,
  },
  header: { label: 'TOKEN MAPPING' },
  cerbosAction: 'read:admin:token-mapping',
  skipWsLoginPaths: [TOKEN_MAPPING_LIST_URL],
} as const satisfies FeatureConfig;
